import { View } from "@react-pdf/renderer";
import { ResumePDFHighlightableText , ResumePDFText } from "components/Resume/ResumePDF/common";
import {
  ResumePDFDescriptionWithWhiteFont,
  TemplateNineteenPDFSection,
  TemplateNineteenSection,
} from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateNineteenSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && (enableHighlight || enableMistakeHighlight) ? (
          <ResumePDFHighlightableText
            text={summary}
            section="profile"
            itemIndex={null}
            style={{ color: "black" }}
            enableMistakeHighlight={enableMistakeHighlight}
          />
        ) : (
          <ResumePDFText themeColor="black">{summary}</ResumePDFText>
        )}
      </View>
    </TemplateNineteenSection>
  );
};
